// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
// import 'lib-flexible/flexible'
import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
import 'swiper/swiper-bundle.css'
Vue.use(ElementUI) //使用elementUI
Vue.config.productionTip = false
Vue.prototype.$ImgHttp = 'https://image.minsuhuipc.com'
Vue.prototype.$share = 'https://mobile.minsuhuipc.com'
Vue.prototype.$appId = 'wx20f96f298d2e163f'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
//引入vuex
import store from './store'
//把vuex定义成全局组件
Vue.prototype.$store = store

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js